import React, { Component } from 'react';
import Hash from 'object-hash';
import { Redirect } from 'react-router-dom';


import RuleForm from '../RuleForm/RuleForm';
import { formatSubmittedRule } from '../../util/util';

class CreateRule extends Component {
    state = {
        ruleId: "",
        isBankAccountCheckboxChecked: false
    }

    componentDidMount() {
        if (!this.props.rules || this.props.rules.length < 1) {
            this.props.fetchRules();
        }
        if (this.props.error) {
            this.props.clearErrorOnCreateRule()
        }
    }

    componentDidUpdate(prevProps) {
        console.log("DID UPDATE");
        console.log("prevProps", prevProps);
        console.log("this.props", this.props);
    }

    verifyRule = (createdRule) => {
        //double equals here for string comparison to integers
        const filteredRules = this.props.rules.filter(rule =>
            // eslint-disable-next-line 
            rule.type_code == createdRule.type_code &&
            // eslint-disable-next-line 
            rule.bank_account == createdRule.bank_account &&
            // eslint-disable-next-line
            rule.customer_ref == createdRule.customer_ref &&
            // eslint-disable-next-line 
            rule.orig_id == createdRule.orig_id &&
            // eslint-disable-next-line
            rule.ind_id_no == createdRule.ind_id_no &&
            // eslint-disable-next-line
            rule.bo_customer == createdRule.bo_customer && 
            // eslint-disable-next-line
            rule.matchBankAccountOnly == createdRule.matchBankAccountOnly
        )

        return filteredRules.length < 1;
    }

    submit = (formValues) => {
        console.log("Create Rules Form Values", formValues);
        this.props.ruleIsSubmitting(true);
        let createdRule = formatSubmittedRule(formValues);
        let updatedTime = (new Date()).toISOString();
        let message = `Rule created by current user.`;
        createdRule.audit = [{ updatedTime, message }];
        createdRule.inactive = false;
        let buttonChoice = createdRule.button;
        delete createdRule.button;
        this.props.createRule(createdRule);

        if (buttonChoice === "audit") {
            this.setState(() => ({
                buttonChoice: "audit",
                ruleId: Hash({ tran_account: createdRule.tran_account, components: createdRule.components })
            }));
        } else if (buttonChoice === "create") {
            this.setState(() => ({
                buttonChoice: "create",
                ruleId: null
            }));
        }
    }

    handleInputChange = (diff) => {
        this.setState({isBankAccountCheckboxChecked:!this.state.isBankAccountCheckboxChecked})
    }

    render() {
        if (this.state.ruleId && this.state.buttonChoice === "audit" && !this.props.ruleSubmitting && !this.props.error && !this.props.invalidWorktags) {
            console.log("REDIRECTED BASED ON THE FOLLOWING STATE - ", this.state, " - AND PROPS - ", this.props);
            return <Redirect to={`/audit/${this.state.ruleId}`} />
        }
        return (
            <div>
                <h1>Create Rule</h1>
                <RuleForm onSubmit={this.submit} submission={this.props.ruleSubmitting} errorOnSubmit={this.props.error} invalidWorktags={this.props.invalidWorktags} />
            </div>
        );
    }
}

export default CreateRule;


// WEBPACK FOOTER //
// ./src/components/CreateRule/CreateRule.js